var map = {
	"./scene-boss-mr-1-opening.webp": 2867,
	"./scene-boss-mr-10-opening.webp": 6879,
	"./scene-boss-mr-2-opening.webp": 8906,
	"./scene-boss-mr-3-opening.webp": 1977,
	"./scene-boss-mr-4-opening.webp": 6016,
	"./scene-boss-mr-5-opening.webp": 2351,
	"./scene-boss-mr-6-opening.webp": 6262,
	"./scene-boss-mr-7-opening.webp": 4917,
	"./scene-boss-mr-8-opening.webp": 444,
	"./scene-boss-mr-9-opening.webp": 4507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3518;